export default "__VITE_ASSET__CHaE9_Fr__"